// components/public/EmailInvalide.js
import React from 'react';
import { Link } from 'react-router-dom';

const EmailInvalide = () => {
    return (
        <div style={{ 
            maxWidth: '600px', 
            margin: '50px auto', 
            textAlign: 'center',
            fontFamily: 'Arial, sans-serif',
            padding: '20px'
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e8e8e8',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Effet de fond */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #dc3545, #e74c3c)'
                }}></div>

                <div style={{ marginBottom: '30px', position: 'relative', zIndex: 1 }}>
                    {/* Icône */}
                    <div style={{
                        background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
                        padding: '25px',
                        borderRadius: '50%',
                        width: '100px',
                        height: '100px',
                        margin: '0 auto 25px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '3px solid #f1b0b7',
                        boxShadow: '0 4px 15px rgba(220, 53, 69, 0.2)'
                    }}>
                        <span style={{ 
                            fontSize: '40px', 
                            color: '#721c24',
                            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                        }}>❌</span>
                    </div>

                    {/* Titre */}
                    <h2 style={{ 
                        color: '#721c24', 
                        marginBottom: '20px',
                        fontSize: '28px',
                        fontWeight: '700',
                        textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                    }}>
                        Email invalide
                    </h2>

                    {/* Solutions */}
                    <div style={{
                        background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                        padding: '20px',
                        borderRadius: '10px',
                        border: '1px solid #90caf9',
                        marginBottom: '25px'
                    }}>
                        <h3 style={{
                            color: '#1565c0',
                            marginBottom: '15px',
                            fontSize: '18px',
                            fontWeight: '600'
                        }}>
                            💡 Comment vous désabonner ?
                        </h3>
                        <p style={{ 
                            color: '#1976d2', 
                            lineHeight: '1.6',
                            fontSize: '15px',
                            margin: '0'
                        }}>
                            <strong>Contactez-nous directement</strong> à l'adresse email ci-dessous 
                            avec le sujet "Désabonnement newsletter"
                        </p>
                    </div>
                </div>

                {/* Actions */}
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    gap: '15px',
                    alignItems: 'center'
                }}>
                    {/* Bouton Contact */}
                    <a 
                        href="mailto:info@inovact.com?subject=Désabonnement newsletter&body=Bonjour, je souhaite me désabonner de vos newsletters."
                        style={{
                            background: 'linear-gradient(135deg, #2c5aa0 0%, #1e3a8a 100%)',
                            color: 'white',
                            padding: '14px 35px',
                            textDecoration: 'none',
                            borderRadius: '8px',
                            fontSize: '16px',
                            fontWeight: '600',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(44, 90, 160, 0.3)',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.background = 'linear-gradient(135deg, #1e3a8a 0%, #1e2a5a 100%)';
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 6px 20px rgba(44, 90, 160, 0.4)';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = 'linear-gradient(135deg, #2c5aa0 0%, #1e3a8a 100%)';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 15px rgba(44, 90, 160, 0.3)';
                        }}
                    >
                        <span style={{ fontSize: '18px' }}>✉️</span>
                        Écrire à info@inovact.com
                    </a>
                </div>

                {/* Informations de contact supplémentaires */}
                <div style={{ 
                    marginTop: '30px', 
                    padding: '20px',
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    <h4 style={{
                        color: '#495057',
                        marginBottom: '10px',
                        fontSize: '14px',
                        fontWeight: '600'
                    }}>
                        📞 Autres moyens de contact
                    </h4>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        fontSize: '13px',
                        color: '#6c757d'
                    }}>
                        <div>
                            <strong>Email :</strong> 
                            <a href="mailto:info@inovact.com" style={{ color: '#2c5aa0', marginLeft: '5px' }}>
                                info@inovact.com
                            </a>
                        </div>
                        <div>
                            <strong>Téléphone :</strong> 
                            <span style={{ marginLeft: '5px' }}>(+229) 58585050</span>
                        </div>
                        {/* <div>
                            <strong>Site web :</strong> 
                            <a href="https://inovact.com" style={{ color: '#2c5aa0', marginLeft: '5px' }}>
                                inovact.com
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Design décoratif */}
            <div style={{
                position: 'fixed',
                top: '10%',
                right: '10%',
                width: '200px',
                height: '200px',
                background: 'radial-gradient(circle, rgba(220,53,69,0.1) 0%, rgba(220,53,69,0) 70%)',
                borderRadius: '50%',
                zIndex: -1
            }}></div>
            <div style={{
                position: 'fixed',
                bottom: '10%',
                left: '10%',
                width: '150px',
                height: '150px',
                background: 'radial-gradient(circle, rgba(44,90,160,0.1) 0%, rgba(44,90,160,0) 70%)',
                borderRadius: '50%',
                zIndex: -1
            }}></div>
        </div>
    );
};

export default EmailInvalide;